import { InferResponseType, useFanforgeApi } from '@hotpot-arcade/fanforge-api-client';
import { useAuth } from '@hotpot-arcade/fanforge-auth';
import { useQuery } from '@tanstack/react-query';
import { AppType } from '@hotpot-arcade/fanforge-api';
import { hc } from 'hono/client';

const apiStub = hc<AppType>('');
const communityGoalCurrent = apiStub['community-goal'].$get;
export type CommunityGoal = InferResponseType<typeof communityGoalCurrent, 200>;

export function useCommunityGoal() {
  const { client: apiClient } = useFanforgeApi();

  const guildId = useAuth((auth) => {
    if (auth.state !== 'authenticated') return undefined;
    if (auth.jwtPayload.amr === 'web') return 'web';
    return auth.jwtPayload.guildId || undefined;
  });

  return useQuery({
    queryKey: ['community-goal', guildId],
    queryFn: async () => {
      const response = await apiClient['community-goal'].$get({ guildId: guildId! });
      if (!response.ok) {
        throw new Error(`Failed to fetch creator: ${response.statusText}`);
      }

      const data = await response.json();
      return data as CommunityGoal;
    },
    enabled: !!guildId,
  });
}
